var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"w-4/5 mx-auto"},[_c('SurveyListener',{attrs:{"id":_vm.surveyID}},[_c('CompareComponent',{attrs:{"surveyID":_vm.surveyID,"one":_vm.one,"two":_vm.two}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }